import * as API from 'aws-amplify/api';
import { ConsoleLogger as Logger } from 'aws-amplify/utils';
import { notification } from 'antd';
import { getDefaultFunctions, createErrorMessage } from './globalStateHelper';

const log = new Logger('context:prices');

async function updateBalancePrices(start, end) {
  try {
    const { body } = await API.get({
      apiName: 'FINTSO',
      path: '/prices/balance',
      options: {
        queryParams: {
          ...(start ? { start } : undefined),
          ...(end ? { end } : undefined),
        },
      },
    }).response;
    const { items: balancePrices } = await body.json();

    this.setState({ balancePrices });
    log.info('balance prices updated with data:', balancePrices);
  } catch (error) {
    const { t } = this.props;
    this.setState({ balancePrices: [] });
    const description = createErrorMessage(error);
    notification.error({
      className: 'notification-error',
      message: t('common.notifications.errorFetchingBalancePrices'),
      description,
    });
    log.error('error fetching balance prices:', createErrorMessage(error, true));
  }
}

async function updateCapacityPrices() {
  try {
    const { body } = await API.get({
      apiName: 'FINTSO',
      path: '/prices/capacity',
    }).response;
    const response = await body.json();
    const { items: capacityPrices, subscription: capacitySubscriptionPrices = [] } = response;
    this.setState({ capacityPrices, capacitySubscriptionPrices });
    log.info('capacity prices updated with data:', capacityPrices);
    log.info('capacity subscription prices updated with data:', capacitySubscriptionPrices);
  } catch (error) {
    const { t } = this.props;
    this.setState({ capacityPrices: [] });
    const description = createErrorMessage(error);
    notification.error({
      className: 'notification-error',
      message: t('common.notifications.errorFetchingCapacityPrices'),
      description,
    });
    log.error('error fetching capacity prices:', createErrorMessage(error, true));
  }
}

const functions = {
  updateBalancePrices,
  updateCapacityPrices,
};

const pricesContext = {
  balancePrices: null,
  capacityPrices: null,
  capacitySubscriptionPrices: null,
  ...getDefaultFunctions(functions),
};

const prices = {
  ...pricesContext,
  ...functions,
};

export {
  pricesContext,
  prices,
};
